import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { colorPalette } from '@rakutenfrance/mui';
import { useTranslate } from '@rakutenfrance/tolgee-provider';
import { EconomicOperatorInformation } from './EconomicOperatorInformation';
export const AvailableContent = ({ data }) => {
    const { t } = useTranslate('legal-economic-operator');
    return (React.createElement(Box, null,
        React.createElement(Stack, { sx: {
                padding: '16px',
                borderRadius: '8px',
                backgroundColor: colorPalette.gray100,
            } },
            React.createElement(Typography, { color: colorPalette.gray900, fontWeight: '600', "data-ts": "responsible_person" }, t('responsible_person', "Personne responsable dans l'UE")),
            React.createElement(Typography, { color: colorPalette.gray900, sx: {
                    marginTop: '8px',
                }, "data-ts": "available_data" }, t('available_data', 'La Personne Responsable dans l’UE ou “Opérateur Economique”, est la personne en charge de nombreux aspects de la conformité et de\
          la sécurité d’un produit sur le marché européen. Si les informations d’un vendeur spécifique n’apparaissent pas ci-dessous, c’est\
          qu’il n’a pas encore transmis les coordonnées de son opérateur économique pour ce produit spécifique. Cette information peut être\
          mise à jour à tout moment. La liste des vendeurs ayant renseigné l’opérateur économique pour ce produit est la suivante :'))),
        data && React.createElement(EconomicOperatorInformation, { data: data })));
};
